export default {
  // 获取单据类型
  get_order_typeName: '/maindata/indexOrder/getHeader',
  // 三方租赁管理合同
  SANFANGLEASECONTRACT: '/econo/econoIndex/getThirdLeaseContract',
  // 监管合同
  SUPERVISECONTRACT: '/econo/econoIndex/getSuperviseContract',
  // 付款申请
  PAYSUPPLY: '/financial/financialIndex/getPaymentApply',
  // 应付结算
  PAYSETTLEMENT: '/financial/financialIndex/getPayableSettlement',
  // 销售发票
  SALESORDER: '/financial/financialIndex/getFinanceSalesInvoice',
  // 应收结算
  RECEIVESETTLEMENT: '/financial/financialIndex/getReceivableSettlement',
  // 租赁合同
  LEASECONTRACT: '/property/propertyIndexOrder/getLeaseContractData',
  // 报修单
  REPAIR: '/property/propertyIndexOrder/getRepairData',
  // 仓储合同
  PARKCONTRACT: '/sales/salesIndexOrder/getWMContractData',
  // 多联项目
  MULTIPROJECT: '/sales/salesIndexOrder/getMTOProjectData',
  // 多联合同
  MULTICONTRACT: '/sales/salesIndexOrder/getMTOContractData',
  // 城矿立项
  CHENGKUANGPROJECT: '/sales/salesIndexOrder/getProjectInitiationData',
  // 物贸立项
  WUMAOPROJECT: '/sales/salesIndexOrder/getGoodsTradeProjectData',
  // 销售合同
  SALESCONTRACT: '/sales/salesIndexOrder/getSalesContractData',
  // 服务合同
  SERVICECONTRACT: '/sales/salesIndexOrder/getServiceContractData',
  // 双边合同
  BILATERALCONTRACT: '/sales/salesIndexOrder/getBilateralContractData',
  // 供方合同、客方合同
  MTOCONTRACT: '/sales/salesIndexOrder/getMTOContractData',
  // 销售合同、采购合同
  SALESANDPURCHASECONTRACT: '/sales/salesIndexOrder/getSalesContractData',
  // 合作伙伴主数据
  PARTNER: '/maindata/indexOrder/getPartner',
  // 仓库主数据
  STOREMASTERDATA: '/maindata/indexOrder/getStorage',
  // 商品主数据
  GOODSMASTER: '/maindata/indexOrder/getProduct',
  // 获取常用文档
  GETDOCUMENT: '/maindata/indexOrder/getHeaderWord',
  // 仓单立项
  CHANGDANLIXIANG: '/sales/salesIndexOrder/getStorageInit',
};
